<template>
  <div id="app" class="bg-custom-gray d-flex flex-column min-vh-100">
    <page-header @update_locale="set_locale($event)" />
    <router-view />
    <page-footer style="margin-top: 75px" />
  </div>
</template>

<i18n>
{
  "en": {
    "meta_description": "Synaplus Solutions is an Artificial Intelligence startup helping firms enhancing their operational performance throught their data",
    "meta_keywords": "automl, artificial intelligence, machine learning, startup, firm, enterprise, operational performance, automl, analytics automation, data science",
    "firstname": "First name",
    "lastname": "Last name",
    "email": "Email",
    "phone": "Phone",
    "company": "Company",
    "role": "Role",
    "country": "Country",
    "request": "Your request",
    "submit": "Submit",
    "help": "How can we help you?",
    "submit": "Submit",
    "aiservice": "Artificial intelligence at your service",
    "start": "Start",
    "sent_message_ok": "Thank you for your message, we will come back to you very soon",
    "sent_message_error": "There was an error sending your message. Please try again later...",
    "trial": "Request a DEMO",
    "question": "General Inquiry",
    "partner": "Partnership",
    "login": "Login",
    "demo": "Demo"
  },
  "fr": {
    "meta_description": "Synaplus Solutions est une startup en intelligence artificielle qui accompagne les entreprises dans l'amélioration de leur performance opérationnelle grâce à leurs données",
    "meta_keywords": "automl, intelligence artificielle, machine learning, startup, entreprise, performance opérationnelle, automl, analytics automation, data science",
    "firstname": "Prénom",
    "lastname": "Nom",
    "email": "Email",
    "phone": "Téléphone",
    "company": "Entreprise",
    "role": "Fonction",
    "country": "Pays",
    "request": "Votre demande",
    "submit": "Envoyer",
    "help": "Comment pouvons-nous vous aider ?",
    "submit": "Envoyer",
    "aiservice": "Mettez l'intelligence artificielle à votre service",
    "start": "Démarrer",
    "sent_message_ok": "Merci pour votre message, nous revenons très vite vers vous",
    "sent_message_error": "Votre message n'a pas pu être envoyé, merci de réessayer plus tard...",
    "trial": "Demander une DEMO",
    "question": "Votre question",
    "partner": "Relation Partenaire",
    "login": "Connexion",
    "demo": "Démo"
  }
}
</i18n>

<i18n>
{
  "en": {
    "meta_description": "Synaplus Solutions is an Artificial Intelligence startup helping firms enhancing their operational performance throught their data",
    "meta_keywords": "automl, artificial intelligence, machine learning, startup, firm, enterprise, operational performance, automl, analytics automation, data science"
  },
  "fr": {
    "meta_description": "Synaplus Solutions est une startup en intelligence artificielle qui accompagne les entreprises dans l'amélioration de leur performance opérationnelle grâce à leurs données",
    "meta_keywords": "automl, intelligence artificielle, machine learning, startup, entreprise, performance opérationnelle, automl, analytics automation, data science"
  }
}
</i18n>

<style lang="scss">
@import './custom-bootstrap.scss';
@import '../node_modules/bootstrap/scss/bootstrap.scss';
@import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css';

@import '../node_modules/hover.css/scss/hover.scss';
@import '../node_modules/flag-icon-css/css/flag-icon.css';
@import './assets/font-awesome-5.8.2/css/all.css';
@import './assets/whhg-font/css/whhg.css';
@import url('https://fonts.googleapis.com/css?family=Bitter');
@import url('https://fonts.googleapis.com/css?family=Montserrat');

.bg-light-grey {
  background-color: #edf2f6;
}

body {
  left: 0;
  margin: 0;
  position: relative;
  font-family: 'Bitter', serif;
  transition: 0.3s;
}
.markdown-body {
  font-family: 'Bitter', serif !important;
}
</style>

<script>
import _ from 'lodash'
import axios from 'axios'

import {
  translate_route,
  untranslate_route,
  language_from_route,
} from '@/router/static_routes.js'

import { mapState } from 'vuex'

import PageHeader from '@/components/page_header.vue'
import PageFooter from '@/components/page_footer.vue'

export default {
  name: 'app',
  components: {
    PageHeader,
    PageFooter,
  },
  data() {
    return {}
  },
  metaInfo() {
    return {
      htmlAttrs: {
        lang: this.$store.state.locale,
      },
      meta: [
        { author: 'Charles-Antoine Giuliani' },
        { description: this.$i18n.t('meta_description') },
        { keywords: this.$i18n.t('meta_keywords') },
      ],
    }
  },
  computed: mapState(['locale']),
  watch: {
    locale: {
      handler(nv, ov) {
        // console.log('update locale real', nv, ov)
        // console.log(this.locale)
        // console.log(this.$store.state.locale)
        // console.log(this.$store.state)
        if (_.isUndefined(nv)) {
          return
        }
        this.$root.$i18n.locale = nv
        // console.log(this.$root.$i18n.locale)
        const canonical_route = untranslate_route(this.$route.path)
        const new_translated_route = translate_route(canonical_route, nv)
        this.$router.push(new_translated_route)
      },
      immediate: true,
    },
  },
  methods: {
    set_locale(val) {
      this.$store.commit('update_locale', val)
    },
  },
  async mounted() {
    let default_language = 'fr'
    try {
      default_language = language_from_route(this.$route.path)
    } catch (error) {
      try {
        default_language = await axios.get('/api/accept_language')
      } catch (error) {
        console.warn('error', error)
      }
    }
    await this.$store.dispatch('init_locale', { default_language })
    let locale = language_from_route(this.$route.path)
    if (locale !== this.$store.state.locale) {
      const canonical_route = untranslate_route(this.$route.path)
      const new_translated_route = translate_route(
        canonical_route,
        this.$store.state.locale
      )
      this.$router.replace(new_translated_route)
    }
  },
}
</script>
